import React, {useState, useEffect, useContext} from 'react';
import ChantierInfoView from './ChantierInfoView';
import {useParams} from 'react-router-dom';
import 'react-datepicker/dist/react-datepicker.css';
import {getChantierIdInfo} from '../../../services/MadricService';
import {MadricContext} from '../../../Context/MadricContext';

/**
 * Les infos d'un chantier
 * @return {JSX}
 */
function ChantierInfo() {
  const {id} = useParams();
  const [chantierInfo, setChantierInfo] = useState({});
  const {whatToShow, setWhatToShow, setIdProjectInfo} = useContext(MadricContext);

  useEffect(() => {
    fetchPlaceIdInfo();
  }, []);

  /** 
   * Permet d'allez chercher les informations d'un chantier
   */
  async function fetchPlaceIdInfo() {
    const chantier = await getChantierIdInfo(id);
    setIdProjectInfo(id);
    setChantierInfo(chantier);
  }

  return (
    <>
      <ChantierInfoView
        chantierInfo={chantierInfo}
        whatToShow={whatToShow}
        setWhatToShow={setWhatToShow}/>
    </>
  );
}

export default ChantierInfo;
